// @todo:es6 we can move all the $f.mobile.localization to here.
// For now, just moving a constant to avoid circular dependency issues

import { AVAILABLE_LOCALES } from '../../constants';
import { CordovaPlugins } from '../../shared/CordovaPlugins';
import { isNative, isWeb } from '../../shared/utils/is';
/**
 * Localization object definition to hold all things related to i18n for mobile.
 * */
const localization = {
    DEFAULT_LOCALE: 'en_US',

    /**
     *
     * Gets the language_locale for the application following this order of precedence:
     *
     * 1) $f.mobile.settings.get('locale')
     * 2) Language defined in the passed in user_model.
     * 3) Language detected in device as long as it is en or es.
     * 4) Default language_locale (en_US).
     * */
    get_locale: function (callback) {
        callback = callback || function () {};

        $f.mobile.settings.get('locale', function (settings_locale) {
            if (!$f.active_user.is_logged_in()) {
                // If not logged in, rely on value stored in settings
                if (settings_locale) {
                    return callback(settings_locale);
                }

                if (isWeb() || isNative()) {
                    // This works on Chrome, Firefox and Opera - does not work for IE
                    var locale = navigator.languages
                        ? navigator.languages[0]
                        : navigator.language || navigator.userLanguage;
                    return callback(localization.map_to_supported_locale(locale));
                }

                CordovaPlugins().globalization.getPreferredLanguage(function (_locale) {
                    return callback(localization.map_to_supported_locale(_locale.value));
                }, null);

                return;
            }

            callback($f.active_user.get('userprofile__locale') || null);
        });
    },

    set_locale: function (locale, auto_change, callback) {
        callback = callback || function () {};
        if (typeof auto_change === 'undefined') {
            auto_change = true;
        }

        // Validate the passed in locale as one of our supported locales.
        locale = this.map_to_supported_locale(locale);

        // Internationalize frameworks that require it.
        if (auto_change) {
            this.set_framework_locales(locale);
        }

        // If a user exists in the current context, set the userprofile__locale model attribute
        if (!$f.active_user.is_logged_in()) {
            // Just store the locale change.
            return $f.mobile.settings.set('locale', locale, callback);
        }

        $f.active_user.set('userprofile__locale', locale);
        callback();
    },

    set_framework_locales: function (locale) {
        if (!locale) {
            return;
        }

        i18next.changeLanguage(locale);
        moment.locale(locale); // moment is smart enough to interpret the lang from the locale
    },

    initialize: function (callback) {
        var this_ = this;
        localization.get_locale(function (locale) {
            this_.set_framework_locales(locale);

            callback(locale);
        });
    },

    /** *
     * This maps the detected locale to our "known" locales. They are 'en_US' and 'es_ES' for now.
     *
     * @param detected_locale <ISO-639 Language Codes>_<ISO-3166 Country Codes>
     * @returns supported <ISO-639 Language Codes>_<ISO-3166 Country Codes>
     */
    map_to_supported_locale: function (locale) {
        locale = locale || '';
        locale = locale.replace('-', '_');

        if (!locale) {
            return this.DEFAULT_LOCALE;
        }

        if (!_.contains(AVAILABLE_LOCALES, locale)) {
            // See if we can find a similar local
            var lang = this.locale_to_lang(locale);
            locale = null;

            _.each(AVAILABLE_LOCALES, function (locale_item) {
                if (locale_item.indexOf(lang) !== 0) {
                    return true;
                } // continue

                locale = locale_item;
                return false;
            });

            return locale || this.DEFAULT_LOCALE;
        }

        return locale;
    },

    /** *
     * This maps the detected locale or language to our "known" languages. They are 'en' and 'es' for now.
     *
     * @param detected_locale <ISO-639 Language Codes>_<ISO-3166 Country Codes> or just <ISO-639 Language Codes>
     * @returns supported <ISO-639 Language Codes>
     */
    map_to_supported_lang: function (detected_locale) {
        if (!_.contains(AVAILABLE_LOCALES, detected_locale)) {
            return 'en';
        }
        return this.locale_to_lang(detected_locale);
    },

    locale_to_lang: function (locale) {
        if (locale.indexOf('_') === -1) {
            return locale;
        }
        return locale.split('_')[0];
    }
};

export default localization;
